export enum LoadingStatus {
  LOADING,
  SUCCESS,
  FAILURE,
}

export enum ProcessingStatus {
  IDLE,
  PROCESSING,
  FAILURE,
}
